export const calcDate = (date1, date2) => {
  let date3 = date2 - date1;

  let days = Math.floor(date3 / (24 * 3600 * 1000));

  let leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000));

  let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000));

  let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
  let seconds = Math.round(date3 / 1000);
  return {
    leave1,
    leave2,
    leave3,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

/**
 * 日期格式化
 */
export function dateFormat(date, format) {
  if (!date) {
    return "";
  }

  format = format || "yyyy-MM-dd hh:mm:ss";
  if (typeof date === "string") {
    date = dateStrToDate(date);
  }

  if (date !== "Invalid Date") {
    let o = {
      "M+": date.getMonth() + 1, //month
      "d+": date.getDate(), //day
      "h+": date.getHours(), //hour
      "m+": date.getMinutes(), //minute
      "s+": date.getSeconds(), //second
      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
      S: date.getMilliseconds() //millisecond
    };
    if (/(y+)/.test(format))
      format = format.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (let k in o)
      if (new RegExp("(" + k + ")").test(format))
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    return format;
  }
  return "";
}

/**
 * 获取礼拜几 数字  0开始
 */
export function getWeekDay(dateTime) {
  let date;
  if (typeof dateTime === "string") {
    date = new Date(dateTime.replace(/-/g, "/"));
  } else {
    date = dateTime;
  }
  let week = date.getDay() - 1;
  return week;
}

/**
 * 按类型获取时间段
 *
 * @param endDateStr 时间基准点
 * @param type :  day month week year lastYear
 * @param count 需要几个范围往前
 * @param format 格式化
 */
export function getDateRange(endDateStr, type, count, format = "yyyy-MM-dd") {
  let endDate;
  if (typeof endDateStr === "string") {
    endDate = new Date(endDateStr.replace(/-/g, "/"));
  } else {
    endDate = endDateStr;
  }

  let dateRanges = [];

  let dd;

  if (type === "week") {
    let week = endDate.getDay();
    let x = (Math.abs(7 - week) % 7) + 1;
    dd = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate() + x
    );
  } else if (type === "month") {
    dd = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 1);
  } else if (type === "day") {
    dd = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate() + 1
    );
  } else if (type === "year") {
    dd = new Date(endDate.getFullYear() + 1, 0, 1);
  } else if (type === "lastYear") {
    dd = new Date(endDate.getFullYear(), 0, 1);
  }

  for (let i = 0; i < count; i++) {
    let end;
    if (type === "day") {
      end = new Date(dd.getFullYear(), dd.getMonth(), dd.getDate() - 1);
    } else if (type === "week") {
      end = new Date(dd.getFullYear(), dd.getMonth(), dd.getDate() - 7);
    } /*if (type === 'month' || type === 'year' || type === 'lastYear') */ else {
      end = new Date(dd.getFullYear(), dd.getMonth() - 1, dd.getDate());
    }

    dateRanges.push({
      start: dateToStr(end, format),
      end: dateToStr(dd, format)
    });
    dd = end;
  }
  dateRanges.reverse();
  return dateRanges;
}

export function dateToStrDay(dateStr) {
  if (dateStr === null || dateStr.length === 0) {
    return "-";
  }
  let date = new Date(dateStr.replace(/-/g, "/"));
  return dateToStr(date, "yyyy-MM-dd");
}

/**
 * 日期对象转换为指定格式的字符串
 * @param date Date日期对象, 如果缺省，则为当前时间
 * @param f 日期格式,格式定义如下 yyyy-MM-dd HH:mm:ss
 *
 * YYYY/yyyy/YY/yy 表示年份
 * MM/M 月份
 * W/w 星期
 * dd/DD/d/D 日期
 * hh/HH/h/H 时间
 * mm/m 分钟
 * ss/SS/s/S 秒
 * @return string 指定格式的时间字符串
 */
export function dateToStr(date, formatStr) {
  formatStr = arguments[1] || "yyyy-MM-dd HH:mm";
  date = arguments[0] || new Date();
  let str = formatStr;
  let Week = ["日", "一", "二", "三", "四", "五", "六"];
  str = str.replace(/yyyy|YYYY/, date.getFullYear());
  str = str.replace(
    /yy|YY/,
    date.getYear() % 100 > 9
      ? (date.getYear() % 100).toString()
      : "0" + (date.getYear() % 100)
  );
  str = str.replace(
    /MM/,
    date.getMonth() > 9 - 1 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
  );
  str = str.replace(/M/g, date.getMonth() + 1);
  str = str.replace(/w|W/g, Week[date.getDay()]);

  str = str.replace(
    /dd|DD/,
    date.getDate() > 9 ? date.getDate().toString() : "0" + date.getDate()
  );
  str = str.replace(/d|D/g, date.getDate());

  str = str.replace(
    /hh|HH/,
    date.getHours() > 9 ? date.getHours().toString() : "0" + date.getHours()
  );
  str = str.replace(/h|H/g, date.getHours());
  str = str.replace(
    /mm/,
    date.getMinutes() > 9
      ? date.getMinutes().toString()
      : "0" + date.getMinutes()
  );
  str = str.replace(/m/g, date.getMinutes());

  str = str.replace(
    /ss|SS/,
    date.getSeconds() > 9
      ? date.getSeconds().toString()
      : "0" + date.getSeconds()
  );
  str = str.replace(/s|S/g, date.getSeconds());

  return str;
}

export function dateStrToStr(dateStr, formatStr) {
  if (dateStr === null) {
    return "-";
  }
  let date;
  if (typeof dateStr === "string") {
    date = new Date(dateStr.replace(/-/g, "/"));
  } else {
    date = new Date(dateStr);
  }
  return dateToStr(date, formatStr);
}

export function dateStrToDate(dateStr) {
  if (dateStr === null) {
    return "-";
  }
  let date;
  if (typeof dateStr === "string") {
    date = new Date(dateStr.replace(/-/g, "/"));
  } else {
    date = new Date(dateStr);
  }
  return date;
}

/**
 * 日期对象转换为毫秒数
 */
export function dateToLong(date) {
  return date.getTime();
}

/**
 * 日期计算
 * @param strInterval string  可选值 y 年 m月 d日 w星期 ww周 h时 n分 s秒
 * @param num int
 * @param date Date 日期对象
 * @return Date 返回日期对象
 */
export function dateAdd(strInterval, num, date) {
  date = arguments[2] || new Date();
  switch (strInterval) {
    case "s":
      return new Date(date.getTime() + 1000 * num);
    case "n":
      return new Date(date.getTime() + 60000 * num);
    case "h":
      return new Date(date.getTime() + 3600000 * num);
    case "d":
      return new Date(date.getTime() + 86400000 * num);
    case "w":
      return new Date(date.getTime() + 86400000 * 7 * num);
    case "m":
      return new Date(
        date.getFullYear(),
        date.getMonth() + num,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      );
    case "y":
      return new Date(
        date.getFullYear() + num,
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      );
  }
}

/**
 * 比较日期差 dtEnd 格式为日期型或者有效日期格式字符串
 * @param strInterval string  可选值 y 年 m月 d日 w星期 ww周 h时 n分 s秒
 * @param dtStart Date  可选值 y 年 m月 d日 w星期 ww周 h时 n分 s秒
 * @param dtEnd Date  可选值 y 年 m月 d日 w星期 ww周 h时 n分 s秒
 */
export function dateDiff(strInterval, dtStart, dtEnd) {
  switch (strInterval) {
    case "s":
      return parseInt((dtEnd - dtStart) / 1000);
    case "n":
      return parseInt((dtEnd - dtStart) / 60000);
    case "h":
      return parseInt((dtEnd - dtStart) / 3600000);
    case "d":
      return parseInt((dtEnd - dtStart) / 86400000);
    case "w":
      return parseInt((dtEnd - dtStart) / (86400000 * 7));
    case "m":
      return (
        dtEnd.getMonth() +
        1 +
        (dtEnd.getFullYear() - dtStart.getFullYear()) * 12 -
        (dtStart.getMonth() + 1)
      );
    case "y":
      return dtEnd.getFullYear() - dtStart.getFullYear();
  }
}

/**
 * 把指定格式的字符串转换为日期对象yyyy-MM-dd HH:mm:ss
 *
 */
export function strFormatToDate(formatStr, dateStr) {
  let year = 0;
  let start = -1;
  let len = dateStr.length;
  if ((start = formatStr.indexOf("yyyy")) > -1 && start < len) {
    year = dateStr.substr(start, 4);
  }
  let month = 0;
  if ((start = formatStr.indexOf("MM")) > -1 && start < len) {
    month = parseInt(dateStr.substr(start, 2)) - 1;
  }
  let day = 0;
  if ((start = formatStr.indexOf("dd")) > -1 && start < len) {
    day = parseInt(dateStr.substr(start, 2));
  }
  let hour = 0;
  if (
    ((start = formatStr.indexOf("HH")) > -1 ||
      (start = formatStr.indexOf("hh")) > 1) &&
    start < len
  ) {
    hour = parseInt(dateStr.substr(start, 2));
  }
  let minute = 0;
  if ((start = formatStr.indexOf("mm")) > -1 && start < len) {
    minute = dateStr.substr(start, 2);
  }
  let second = 0;
  if ((start = formatStr.indexOf("ss")) > -1 && start < len) {
    second = dateStr.substr(start, 2);
  }
  return new Date(year, month, day, hour, minute, second);
}

/**
 * 日期对象转换为毫秒数
 */
export function dateStrToLong(dateStr) {
  return dateStrToDate(dateStr).getTime();
}

/**
 * 毫秒转换为日期对象
 * @param dateVal number 日期的毫秒数
 */
export function longToDate(dateVal) {
  return new Date(dateVal);
}

/**
 * 判断字符串是否为日期格式
 * @param str string 字符串
 * @param formatStr string 日期格式， 如下 yyyy-MM-dd
 */
export function isDate(str, formatStr) {
  if (formatStr == null) {
    formatStr = "yyyyMMdd";
  }
  let yIndex = formatStr.indexOf("yyyy");
  if (yIndex === -1) {
    return false;
  }
  let year = str.substring(yIndex, yIndex + 4);
  let mIndex = formatStr.indexOf("MM");
  if (mIndex === -1) {
    return false;
  }
  let month = str.substring(mIndex, mIndex + 2);
  let dIndex = formatStr.indexOf("dd");
  if (dIndex === -1) {
    return false;
  }
  let day = str.substring(dIndex, dIndex + 2);
  if (!isNumber(year) || year > "2100" || year < "1900") {
    return false;
  }
  if (!isNumber(month) || month > "12" || month < "01") {
    return false;
  }
  if (day > getMaxDay(year, month) || day < "01") {
    return false;
  }
  return true;
}

export function getMaxDay(year, month) {
  if (month === 4 || month === 6 || month === 9 || month === 11) return "30";
  if (month === 2)
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) return "29";
    else return "28";
  return "31";
}

/**
 *    变量是否为数字
 */
export function isNumber(str) {
  let regExp = /^\d+$/g;
  return regExp.test(str);
}

/**
 * 把日期分割成数组 [年、月、日、时、分、秒]
 */
export function toArray(myDate) {
  myDate = arguments[0] || new Date();
  let myArray = Array();
  myArray[0] = myDate.getFullYear();
  myArray[1] = myDate.getMonth();
  myArray[2] = myDate.getDate();
  myArray[3] = myDate.getHours();
  myArray[4] = myDate.getMinutes();
  myArray[5] = myDate.getSeconds();
  return myArray;
}

/**
 * 取得日期数据信息
 * 参数 interval 表示数据类型
 * y 年 M月 d日 w星期 ww周 h时 m分 s秒
 */
export function datePart(interval, myDate) {
  myDate = arguments[1] || new Date();
  let partStr = "";
  let Week = ["日", "一", "二", "三", "四", "五", "六"];
  switch (interval) {
    case "y":
      partStr = myDate.getFullYear();
      break;
    case "M":
      partStr = myDate.getMonth() + 1;
      break;
    case "d":
      partStr = myDate.getDate();
      break;
    case "w":
      partStr = Week[myDate.getDay()];
      break;
    case "ww":
      partStr = getYearWeek(myDate);
      break;
    case "h":
      partStr = myDate.getHours();
      break;
    case "m":
      partStr = myDate.getMinutes();
      break;
    case "s":
      partStr = myDate.getSeconds();
      break;
  }
  return partStr;
}

export function getYearWeek(date) {
  date = date || new Date();
  let firstDayOfYear = new Date(date.getFullYear(), 0, 1);
  let dateWeekNum = firstDayOfYear.getDay() - 1;
  if (dateWeekNum < 0) {
    dateWeekNum = 6;
  }
  if (dateWeekNum < 4) {
    //前移日期
    firstDayOfYear.setDate(firstDayOfYear.getDate() - dateWeekNum);
  } else {
    //后移日期
    firstDayOfYear.setDate(firstDayOfYear.getDate() + 7 - dateWeekNum);
  }
  let d = Math.round((date.valueOf() - firstDayOfYear.valueOf()) / 86400000);
  if (d < 0) {
    return getYearWeek(new Date(date.getFullYear(), 0, 0));
  } else {
    return Math.ceil((d + 1) / 7);
  }
}

/**
 * 取得日期数据信息
 * 参数 interval 表示数据类型
 * y 年 M月 d日 w星期 ww周 h时 n分 s秒
 */
export function dateStrPart(interval, myDate) {
  return datePart(interval, dateStrToDate(myDate));
}

/**
 * 取得当前日期所在月的最大天数
 */
export function maxDayOfDate(date) {
  date = arguments[0] || new Date();
  date.setDate(1);
  date.setMonth(date.getMonth() + 1);
  let time = date.getTime() - 24 * 60 * 60 * 1000;
  let newDate = new Date(time);
  return newDate.getDate();
}

/**
 * 时间显示格式（刚刚、几分钟前、几小时前、昨天 + 时间、 前天 + 时间 、 普通时间）
 * @param timeStr
 *
 */
export function getRegionTime(timeStr) {
  let date = dateStrToDate(timeStr); //目标时间

  let time = dateToLong(date);

  let regionTime = "";
  if (time === 0) return regionTime;
  let strDate = dateToStr(date, "yyyy-MM-dd");
  let curDate = new Date(); //今天
  let strCurDate = dateToStr(curDate, "yyyy-MM-dd");

  let b1Date = dateAdd("d", -1, curDate); //昨天
  let strB1Date = dateToStr(b1Date, "yyyy-MM-dd");

  let b2Date = dateAdd("d", -1, b1Date); //前天

  let strB2Date = dateToStr(b2Date, "yyyy-MM-dd");

  let now = dateToLong(new Date());
  let nowDate = longToDate(now);

  if (strDate === strCurDate) {
    //今天

    let datetime = (now - time) / 1000; //秒

    if (datetime > 60 * 60) {
      regionTime = parseInt(datetime / (60 * 60)) + "小时前";
    } else if (datetime > 60) {
      regionTime = parseInt(datetime / 60) + "分钟前";
    } else {
      regionTime = "刚刚";
    }
  } else if (strDate === strB1Date) {
    //昨天
    regionTime = "昨天  " + dateToStr(date, "HH:mm");
  } else if (strDate === strB2Date) {
    //前天
    regionTime = "前天  " + dateToStr(date, "HH:mm");
  } else {
    //三天前

    let year = dateToStr(date, "yyyy");

    let nowYear = dateToStr(nowDate, "yyyy");
    if (nowYear === year) {
      regionTime = dateToStr(date, "MM-dd");
    } else {
      regionTime = dateToStr(date, "yyyy-MM-dd");
    }
  }
  return regionTime;
}
